import { StyledDropdown } from '@tmh-website/ui/Dropdown';
import styled from 'styled-components';

export const Container = styled(StyledDropdown.Container)`
  padding: 0;
`;
